import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import clsx from "clsx"

import { Button } from "components"
import { isDirectionLtr } from "utils"
import { changeDeliveryType } from "@redux"
import classes from "./index.module.scss"

const KioskDeliveryTypes = () => {
  const kioskDeliveryTypes = [
    "dineIn",
    "selfPickup",
    "cinema"
  ]

  const userAccountInfo =
    useSelector(state => state.userAccountInfo)

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const handleGoBack = () => {
    const route =
      location.state?.redirectFrom ||
      "/kiosk-languages"

    history.push(route)
  }

  const handleClick = (deliveryType) => {
    dispatch(
      changeDeliveryType(deliveryType)
    )

    const route =
      location.state?.redirectFrom ||
      (deliveryType === "cinema" ? "/kiosk-cinema-solons" : "/kiosk-foods")

    history.push(route)
  }

  const isLtr =
    isDirectionLtr(i18n.language)

  const cashierBranch =
    userAccountInfo.selectedCashierBranch?._id
      ? userAccountInfo.selectedCashierBranch
      : userAccountInfo.cashierBranches.find(cashierBranch =>
        userAccountInfo.branchId === cashierBranch._id ||
        userAccountInfo.branchId === cashierBranch.branchId
      )

  const onlyThisDeliveries =
    cashierBranch?.onlyThisDeliveries || []

  const hasKioskCompatibleDeliveryType =
    onlyThisDeliveries.some(deliveryType =>
      kioskDeliveryTypes.includes(deliveryType)
    )

  const showAllOptions =
    onlyThisDeliveries.length === 0 ||
    !hasKioskCompatibleDeliveryType

  const showDineInOption =
    showAllOptions ||
    onlyThisDeliveries.includes("dineIn")

  const showSelfPickupOption =
    showAllOptions ||
    onlyThisDeliveries.includes("selfPickup")

  const showCinemaOption =
    showAllOptions ||
    onlyThisDeliveries.includes("cinema")

  return (
    <div className={classes["container"]}>
      <div className={classes["header"]}>
        <Button
          className={classes["button"]}
          onClick={handleGoBack}
        >
          {isLtr ? <FaChevronLeft size={18} /> : <FaChevronRight size={18} />}

          <span
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            {t("بازگشت")}
          </span>
        </Button>
      </div>

      <div className={classes["row"]}>
        {
          showSelfPickupOption &&
          <div
            onClick={() => handleClick("selfPickup")}
            className={classes["self-pickup"]}
          >
            <h2 className={classes["title"]}>
              {t("بیرون_بر")}
            </h2>

            <img
              className={classes["image"]}
              src="/assets/images/kiosk-takeaway.jpg"
              alt={t("بیرون_بر")}
            />
          </div>
        }

        {
          showDineInOption &&
          <div
            onClick={() => handleClick("dineIn")}
            className={classes["dine-in"]}
          >
            <h2 className={classes["title"]}>
              {t("سالن")}
            </h2>

            <img
              className={classes["image"]}
              src="/assets/images/kiosk-dine-in.jpg"
              alt={t("سالن")}
            />
          </div>
        }

        {
          showCinemaOption &&
          <div
            onClick={() => handleClick("cinema")}
            className={classes["cinema"]}
          >
            <h2 className={classes["title"]}>
              {t("سینما")}
            </h2>

            <img
              className={classes["image"]}
              src="/assets/images/kiosk-cinema.jpg"
              alt={t("سینما")}
            />
          </div>
        }
      </div>
    </div>
  )
}

export default KioskDeliveryTypes
